export type Addons =
  | 'BILLING'
  | 'TEST_BILLING'
  | 'SUGGESTED_PROMPTS'
  | 'TAGS'
  | 'TABLE'
  | 'CONVERSATION_API'
  | 'GEO'
  | 'SIMPLE_KEYWORDS'
  | 'LOOKER_STUDIO'
  | 'EXPORT_DATA'
  | 'SOURCES_STATS'
  | 'SOURCES_STATS_ADVANCED'
  | 'REPORTS'
  | 'CONTEXT_INSIGHTS'
  | 'API_KEYS'
  | 'ONLY_SUPERADMIN_FEATURE'
  | 'PAUSE_MODE'
  | 'CLAUDE_WEB'
  | 'WEEKLY_CLAUDE_WEB'
  | 'EXPORT_LLM_RESPONSE'
  | 'GEO_REPORT'
  | 'IMPORT_FROM_CSV'
  | 'PROJECT_GROUPS'
  | 'PROMPT_GROUP'
  | 'AGENCY'
  | 'SOURCES_3_0'
  | 'KEYWORDS_PAGE'
  | 'ANOMALY_DETECTION'
  | 'NEW_STATS';

export const allAddons: Addons[] = [
  'SUGGESTED_PROMPTS',
  'TAGS',
  'TABLE',
  'CONVERSATION_API',
  'GEO',
  'SIMPLE_KEYWORDS',
  'LOOKER_STUDIO',
  'EXPORT_DATA',
  'SOURCES_STATS',
  'SOURCES_STATS_ADVANCED',
  'REPORTS',
  'CONTEXT_INSIGHTS',
  'API_KEYS',
  'ONLY_SUPERADMIN_FEATURE',
  'PAUSE_MODE',
  'CLAUDE_WEB',
  'WEEKLY_CLAUDE_WEB',
  'EXPORT_LLM_RESPONSE',
  'GEO_REPORT',
  'IMPORT_FROM_CSV',
  'PROJECT_GROUPS',
  'PROMPT_GROUP',
  'AGENCY',
  'SOURCES_3_0',
  'KEYWORDS_PAGE',
  'ANOMALY_DETECTION',
  'NEW_STATS',
];
